import { render, staticRenderFns } from "./TestRouter.vue?vue&type=template&id=a55163a8"
import script from "./TestRouter.vue?vue&type=script&lang=js"
export * from "./TestRouter.vue?vue&type=script&lang=js"
import style0 from "./TestRouter.vue?vue&type=style&index=0&id=a55163a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports